import { render, staticRenderFns } from "./EzRolesList.vue?vue&type=template&id=64603680&scoped=true&"
import script from "./EzRolesList.vue?vue&type=script&lang=js&"
export * from "./EzRolesList.vue?vue&type=script&lang=js&"
import style0 from "./EzRolesList.vue?vue&type=style&index=0&id=64603680&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64603680",
  null
  
)

export default component.exports